import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccountBillStatusList,
  getAccountBillStatusById,
  createAccountBillStatus,
  updateAccountBillStatus,
  deleteAccountBillStatus,
} from "api/accountBillStatusApi"

export const ACCOUNT_BILL_STATUS_QUERY_KEY = "account-bill-status"

export const useAccountBillStatuses = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_BILL_STATUS_QUERY_KEY,
    getAccountBillStatusList,
    params,
    enabled
  )
}

export const useAccountBillStatus = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_BILL_STATUS_QUERY_KEY,
    getAccountBillStatusById,
    id,
    enabled
  )
}

export const useCreateAccountBillStatus = () => {
  return useCreateResource(
    createAccountBillStatus,
    ACCOUNT_BILL_STATUS_QUERY_KEY
  )
}

export const useEditAccountBillStatus = () => {
  return useEditResource(
    updateAccountBillStatus,
    ACCOUNT_BILL_STATUS_QUERY_KEY
  )
}

export const useDeleteAccountBillStatus = () => {
  return useDeleteResource(
    deleteAccountBillStatus,
    ACCOUNT_BILL_STATUS_QUERY_KEY
  )
}
